module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.styleText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('TrendRe')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('period')) + ": " + _vm._s(_vm.timeRange))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('img', {
    staticClass: "graph",
    attrs: {
      "id": "img4_1"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "rowspan": "2",
      "width": "9%"
    }
  }, [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "10",
      "width": "29%"
    }
  }, [_vm._v(_vm._s(_vm.$t('Basics')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('distri')) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "4",
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('stab')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(_vm._s(_vm.$t('BG1')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('max')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('min')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Med')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Q1')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Q3')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('IQR')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('SD')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('CV')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('SE1')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('high')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('low')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('target')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('aucAbove')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('aucBelow')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('#high')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('#low')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('high')) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('low')) + "%")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('target')) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('SD')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('#hypo')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('bgRead')))])]), _vm._v(" "), _vm._l((_vm.xDate2), function(day, j) {
    return _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(day))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_avg))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_max))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_min))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_median))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_q1))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_q3))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_iqr))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_sd))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_cv))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_se))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_up))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_lp))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_tp))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_aucu))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_aucl))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_nu))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_nl))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_up))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_lp))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_tp))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_avg))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_sd))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_hypo_num))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_num))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Avg/Total')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_avg))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_max))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_min))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_median))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_q1))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_q3))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_iqr))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_sd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_cv))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_se))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_up))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_lp))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_tp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_aucu))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_aucl))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_nu))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_nl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_up))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_lp))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_tp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_avg))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_sd))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_hypo_num))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_num))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page-seperator"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('img', {
    staticClass: "graph",
    attrs: {
      "id": "img4_2"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "statics spe-statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table",
    class: {
      'de2': _vm.isDe
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "rowspan": "2",
      "width": "11%"
    }
  }, [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.$t('insulin2')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('total')) + " " + _vm._s(_vm.$t('ins_unit')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('avg_daily_basal')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('avg_daily_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofBolus')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('avgBolus')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('carbs')) + " (g)")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofMeal')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Dura1')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('ofExer')))])]), _vm._v(" "), _vm._l((_vm.xDate2), function(day, i) {
    return _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(day))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].ins_total))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_c('span', {
      staticClass: "value_percent_cell left_value"
    }, [_vm._v(_vm._s(_vm.event[i].ins_basal))]), _vm._v(" "), _c('span', {
      staticClass: "value_percent_cell right_percent"
    }, [_vm._v(_vm._s(_vm.event[i].ins_basal_p))])]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_c('span', {
      staticClass: "value_percent_cell left_value"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus))]), _vm._v(" "), _c('span', {
      staticClass: "value_percent_cell right_percent"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus_p))])]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus_n))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus_avg))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].carb_gram))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].carb_num))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].exer_time))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.event[i].exer_num))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Avg/Total')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_total))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_c('span', {
    staticClass: "value_percent_cell left_value"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_basal))]), _vm._v(" "), _c('span', {
    staticClass: "value_percent_cell right_percent"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_basal_p))])]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_c('span', {
    staticClass: "value_percent_cell left_value"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus))]), _vm._v(" "), _c('span', {
    staticClass: "value_percent_cell right_percent"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus_p))])]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus_n))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus_avg))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].carb_gram))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].carb_num))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].exer_time))]), _c('td', [_vm._v(_vm._s(_vm.event[_vm.dayNum].exer_num))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/LOGO.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5d45d04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print-htmplate/chart4_print.vue
// module id = 1493
// module chunks = 7